import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'

import './css/index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import vconsole from 'vconsole'
import { devtools } from 'stook-devtools'
import xdragonBridge from  './utils/xdragon-bridge'
import SentryInit from './utils/sentry'

if (process.env.REACT_APP_DELOY_ENV === 'test') {
   new vconsole();
   devtools.init()
} else {
  SentryInit()
}

xdragonBridge.init()

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
